import React from 'react'
import PropTypes from 'prop-types'
import { IconsRenderer } from './IconsRenderer'
import { CtaRenderer } from './CtaRenderer'
const isEmpty = require("lodash/isEmpty")

import './style.css.scss'

const Paragraph = (props) => {

  const getEmptyClass = () => {
    return ((!!props.data.title && !isEmpty(props.data.title))
      || (!!props.data.description && !isEmpty(props.data.description)))
      ? ""
      : "empty"
  }

  return (
    <span className={`side-by-side-paragraph ${getEmptyClass()}`}>
      { props.data.title && (<h1>{props.data.title}</h1>) }
      { props.data.description && (<p>{props.data.description}</p>) }
      { props.data.icons &&
        (<IconsRenderer
          iconsData={props.data.icons}
          themeColorHex={props.themeColorHex}/>) }
      { props.data.cta.show &&
        (<CtaRenderer
          ctaData={props.data.cta}
          themeColorHex={props.themeColorHex} />) }
    </span>
  )
}

Paragraph.propTypes = {
  data: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default Paragraph
